import type { AssetWithBalance } from '@/types';
import usePrice from '@/ui/hooks/use-price';
import { useNavigate } from '@/ui/utils/navigation';
import BaseItem from './base-item.js';

type SingleItemProps = {
  asset: AssetWithBalance;
  displayName?: string;
  withChain?: boolean;
  className?: string;
  dataTestId?: string;
};

function SingleItem({
  asset,
  displayName: displayNameOverride,
  withChain = false,
  className,
  dataTestId,
}: SingleItemProps) {
  const { loading, value: price } = usePrice(asset.ticker);

  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/tokens/${asset.name}`);
  };

  const displayName = displayNameOverride || asset.displayName;

  return (
    <BaseItem
      name={asset.name}
      displayName={displayName}
      itemName={displayName}
      displayTicker={asset.displayTicker}
      chainName={withChain ? asset.baseAssetName : undefined}
      balance={asset.balance.toDefaultNumber()}
      fiatValue={asset.fiatValue.toDefaultNumber()}
      price={price}
      loading={loading}
      className={className}
      onClick={handleClick}
      dataTestId={dataTestId}
    />
  );
}

export default SingleItem;
